import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import flexible from "flexible.js";
import ElementUI from 'element-ui';
import "@/utils/flexible.js";
import "@/style/base.css";
import '@/style/index.css';
import 'element-ui/lib/theme-chalk/index.css';
// flexible();
Vue.config.productionTip = false;
Vue.use(ElementUI);
new Vue({
  router,
  render: (h) => h(App),
}).$mount("#app");
